// extracted by mini-css-extract-plugin
export default {"text-container":"TextLayout_text-container__XRhmO","title":"TextLayout_title__CRlr0","description":"TextLayout_description__oI1YA","concluding":"TextLayout_concluding__FZp-1"};